import { useFetcher } from "~/hooks/useFetcher";
import { TableLineageResponse } from "~/pages/datasets/types/interfaces/lineage";

const { VITE_CATALOG_API } = import.meta.env;

export const useTableLineage = (tableFQN?: string) => {
  const { data, isLoading, error } = useFetcher<TableLineageResponse>(
    tableFQN
      ? `${VITE_CATALOG_API}/tables/fqn/${tableFQN}/lineage?upstream_depth=2&downstream_depth=2`
      : null,
    { shouldCamelize: "data" }
  );

  return { data, isLoading, error };
};
